import * as React from "react";
import { Nullable } from "../../../types/utils";
import ButtonInverted from "../Buttons/ButtonInverted";
import OrderPDF from "../OrderPDF";
import PdfProvider from "../PdfProvider";
import { OrderCostingVersion, TApiOrderDetails } from "../../api/endpoints/Order";
import { TApiSet } from "../../api/endpoints/Set";
import { TApiProvider } from "../../api/endpoints/Provider";
import { TOrderProduct } from "../../api/endpoints/OrderProduct";
import { TApiServicePackage } from "../../api/endpoints/ServicePackage";
import { TApiVolumeBand } from "../../api/endpoints/VolumeBand";

interface IProps {
  order: TApiOrderDetails;
  currentCostingVersion: Nullable<OrderCostingVersion>;
  sets: Array<TApiSet>;
  provider?: TApiProvider;
  dataDeliverer?: TApiProvider;
  servicePackage?: TApiServicePackage;
  volumeBand?: TApiVolumeBand;
  orderProducts?: Array<TOrderProduct>;
  disabled?: boolean;
}

/**
 * A button which downloads a PDF of an order.
 */
const OrderPDFButton = (props: IProps) => {
  const {
    order,
    currentCostingVersion,
    sets,
    provider,
    dataDeliverer,
    servicePackage,
    volumeBand,
    orderProducts = [],
    disabled
  } = props;
  const [loadPdf, setLoadPdf] = React.useState(false);

  return (
    <>
      <PdfProvider
        loadPdf={loadPdf}
        setLoadPdf={setLoadPdf}
        name={`order${order.id ?? ''}.pdf`}
      >
        <OrderPDF
          order={order}
          currentCostingVersion={currentCostingVersion}
          products={orderProducts}
          sets={sets}
          provider={provider}
          dataDeliverer={dataDeliverer}
          servicePackage={servicePackage}
          volumeBand={volumeBand}
        />
      </PdfProvider>
      <ButtonInverted
        onClick={() => setLoadPdf(true)}
        text="Download PDF"
        disabled={disabled}
      />
    </>
  );
};

export default OrderPDFButton;
